import {connect} from 'react-redux'
import NavigationView from '../components/NavigationView'

import {changeStep} from "../../../../../layouts/Content/modules/step";
import {completeSession} from "../../../../../store/application";

const mapDispatchToProps = {
  changeStep: changeStep,
  completeSession: completeSession
};

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(NavigationView)


// WEBPACK FOOTER //
// ./src/components/Applications/shared/Navigation/containers/NavigationContainer.js